import React, { Fragment, useMemo, useCallback } from 'react'

import Image from 'next/image'
import Link from 'next/link'

import { ProgressBar, Option, StepError } from '..'
import { setMatchMakerQuestion } from '../../../../services/match-maker'

const AgeSelectionStep = ({ state, dispatch, goToNextStep, goToPreviousStep, maxSteps }) => {
  const underAge = useMemo(() => ['- de 12', '12 a 17'].includes(state.form_values.age), [
    state.form_values.age
  ])

  const submitAgeSelectionStep = useCallback(async () => {
    dispatch({ type: 'set_status', payload: 'loading' })
    try {
      const { data } = await setMatchMakerQuestion({
        id_session: state.id_session,
        answers: [{ question: state.questions[0].id, answer: state.form_values.age }]
      })
      goToNextStep(data)
    } catch {
      dispatch({ type: 'set_status', payload: 'error' })
    }
  }, [state.form_values.age])

  if (state.status === 'error') {
    return (
      <StepError
        stepImage='/static/images/match-maker/01.png'
        submitStep={submitAgeSelectionStep}
      />
    )
  }

  if (underAge) {
    return (
      <Fragment>
        <div className='step__illustration lg:hidden'>
          <img src='/static/images/match-maker/underAge.png' width='100%' />
        </div>
        <div className='step__question'>
          <Image src='/static/images/logo-vittude.svg' width={153} height={50} className='step__question__logo' />
          <p className='step__question__title'>
            Você precisa da autorização de um responsável legal
          </p>
          <p className='step__question__description'>
            Conforme o Art. 5º da{' '}
            <a
              href='https://site.cfp.org.br/wp-content/uploads/2018/05/RESOLU%C3%87%C3%83O-N%C2%BA-11-DE-11-DE-MAIO-DE-2018.pdf'
              target='_blank' rel='noreferrer'
            >
              Resolução CFP 011/2018
            </a>{' '}
            o atendimento online de crianças e adolescentes só pode ocorrer mediante consentimento
            expresso de um dos responsáveis legais.
          </p>
          <div className='flex mb-5 items-center'>
            <button className='button-verm match-maker-button' onClick={submitAgeSelectionStep}>
              Sou o responsável
            </button>
            <Link href='/' className='link-home'>
              Voltar para home
            </Link>
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className='step__illustration lg:hidden'>
        <img src='/static/images/match-maker/01.png' width='100%' />
      </div>
      <div className='step__question'>
        <p className='step__question__title mb-5'>Qual é a sua idade?</p>
        <div className='step__question__template mb-5'>
          <Option
            selected={state.form_values.age === '- de 12'}
            onClick={() => dispatch({ type: 'set_age', payload: '- de 12' })}
          >
            - de 12
          </Option>
          <Option
            selected={state.form_values.age === '12 a 17'}
            onClick={() => dispatch({ type: 'set_age', payload: '12 a 17' })}
          >
            12 a 17
          </Option>
          <Option
            selected={state.form_values.age === '18 a 34'}
            onClick={() => dispatch({ type: 'set_age', payload: '18 a 34' })}
          >
            18 a 34
          </Option>
          <Option
            selected={state.form_values.age === '35 a 54'}
            onClick={() => dispatch({ type: 'set_age', payload: '35 a 54' })}
          >
            35 a 54
          </Option>
          <Option
            selected={state.form_values.age === '55 a 64'}
            onClick={() => dispatch({ type: 'set_age', payload: '55 a 64' })}
          >
            55 a 64
          </Option>
          <Option
            selected={state.form_values.age === '+ de 65'}
            onClick={() => dispatch({ type: 'set_age', payload: '+ de 65' })}
          >
            + de 65
          </Option>
        </div>
        <div className='step__question__info'>
          <div className='step__question__info__next-step-container'>
            <div className='step__question__info__next-step-container__navigation'>
              <button
                className='button-verm-leaked match-maker-button mr-3'
                onClick={goToPreviousStep}
              >
                Voltar
              </button>
              <button
                disabled={!state.can_proceed}
                className='button-verm match-maker-button'
                onClick={submitAgeSelectionStep}
                id='step1-matchmaking'
              >
                Próximo
              </button>
            </div>
            {state.current_step > 0 && (
              <ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export { AgeSelectionStep }
